import pdfListingIcon from "../assets/images/app/digiPub/sidebar/pdf-listing-icon.svg";
import webFormIcon from "../assets/images/app/digiPub/sidebar/web-form-icon.svg";
import SettingsIcon from "../assets/images/app/plate-talk/sidebar-logos/account.svg";

import { Roles } from "../constants";
import { APP_ROUTES } from "../helpers/routeHelpers";

let { Admin } = Roles;

const SIDEBAR_CONFIG = [
    {
        title: "PDF Listing",
        url: APP_ROUTES.PDF_LISTING,
        icon: null,
        menuImg: pdfListingIcon,
        nestedMenu: null,
        permissions: [Admin]
    },
    {
        title: "Web Form",
        url: APP_ROUTES.WEB_FORM,
        icon: null,
        menuImg: webFormIcon,
        nestedMenu: null,
        permissions: [Admin]
    },

    {
        title: "Profile",
        url: APP_ROUTES.ACCOUNT,
        icon: null,
        menuImg: SettingsIcon,
        nestedMenu: null,
        permissions: [Admin]
    }
];

export default SIDEBAR_CONFIG;
